import { useLocation } from 'react-router-dom';

const ROUTE_LABELS: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/registry': 'Lab Registry',
  '/equipment': 'Equipment',
  '/certifications': 'Certifications',
  '/partners': 'Partners',
  '/finder': 'Lab Finder',
  '/capa': 'CAPA / Deviations',
  '/audits': 'Audit Tracker',
  '/sop': 'SOP Management',
  '/bmr': 'Batch Records',
  '/dms': 'Documents',
  '/requests': 'Test Requests',
  '/workflows': 'Workflows',
  '/integrations': 'Integrations',
  '/onboarding': 'Onboard Partner',
  '/bulk-import': 'Bulk Import',
  '/samples': 'Sample Tracking',
  '/change-control': 'Change Control',
  '/training': 'Training & Competency',
  '/calibration-pm': 'Calibration & PM',
  '/quality-metrics': 'Quality Metrics',
  '/user-management': 'User Management',
  '/report-builder': 'Report Builder',
  '/settings': 'Settings',
};

export function useBreadcrumb(customLabel?: string) {
  const location = useLocation();
  const pathLabel = ROUTE_LABELS[location.pathname] || 'Page';

  const crumbs = [
    { label: 'Home', href: '/dashboard' },
    { label: pathLabel, href: location.pathname },
    ...(customLabel ? [{ label: customLabel }] : []),
  ];

  return crumbs;
}
